import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import SlideShow from "./SlideShow";
import "../styles/MainContent.css";

export default function MainContent() {
  const [contentImages, setContentImages] = useState([]);
  const [postcards, setPostcards] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchImages = async () => {
      setLoading(true);
      try {
        const [imagesRes, slidesRes] = await Promise.all([
          fetch(`${process.env.REACT_APP_API_URL}/api/images/main`),
          fetch(`${process.env.REACT_APP_API_URL}/api/images/postcards`),
        ]);

        if (!imagesRes.ok) {
          throw new Error(imagesRes.message || "Failed to load images");
        }

        if (!slidesRes.ok) {
          throw new Error(slidesRes.message || "Failed to load images");
        }

        const [imagesData, slidesData] = await Promise.all([
          imagesRes.json(),
          slidesRes.json(),
        ]);

        setContentImages(imagesData.data.content);
        setPostcards(slidesData.data);
      } catch (err) {
        setError(err.message || "Failed to fetch images");
      } finally {
        setLoading(false);
      }
    };
    fetchImages();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Unable to load images.</div>;
  }

  const safeContentImages = contentImages || [];
  const safePostcards = postcards || [];

  if (!safeContentImages.length || !safePostcards.length) {
    return <div>Loading content...</div>;
  }

  return (
    <div className="intro__content--container">
      {/* Links Section */}
      <section className="intro__links">
        <div className="intro__links--container">
          <div className="intro__links--card">
            <div className="intro__links--header">
              <h2>Picnic and Event Selections</h2>
              <p>
                Explore our selection of picnic and event options for your
                special occasion
              </p>
            </div>
          </div>

          <div className="intro__links--card">
            <div className="intro__links--image">
              <img
                className="intro__image--picnic"
                src={safeContentImages[0]?.src}
                alt="Picnic for 2"
                onContextMenu={(e) => e.preventDefault()}
                draggable="false"
              ></img>
            </div>

            <div className="intro__links--card-content">
              <h3>Couples Picnics</h3>
              <div className="intro__links--buttons ">
                <Link to="/couples" className="intro__links--button my-btn">
                  Couples
                </Link>
              </div>
            </div>
          </div>

          <div className="intro__links--card">
            <div className="intro__links--image">
              <img
                className="intro__image--picnic"
                src={safeContentImages[1]?.src}
                alt={safeContentImages[1]?.alt}
                onContextMenu={(e) => e.preventDefault()}
                draggable="false"
              ></img>
            </div>
            <div className="intro__links--card-content">
              <h3> Group Picnics</h3>
              <div className="intro__links--buttons">
                <Link to="/groups" className="intro__links--button my-btn">
                  Groups
                </Link>
              </div>
            </div>
          </div>

          <div className="intro__links--card">
            <div className="intro__links--image">
              <img
                className="intro__image--picnic"
                src={safeContentImages[3]?.src}
                alt={safeContentImages[3]?.alt}
                onContextMenu={(e) => e.preventDefault()}
                draggable="false"
              ></img>
            </div>
            <div className="intro__links--card-content">
              <h3> Proposal Picnics</h3>
              <div className="intro__links--buttons">
                <Link to="/proposals" className="intro__links--button my-btn">
                  Proposals
                </Link>
              </div>
            </div>
          </div>

          <div className="intro__links--card">
            <div className="intro__links--image">
              <img
                className="intro__image--picnic"
                src={safeContentImages[2]?.src}
                alt={safeContentImages[2]?.alt}
                onContextMenu={(e) => e.preventDefault()}
                draggable="false"
              ></img>
            </div>
            <div className="intro__links--card-content">
              <h3> Your Special Event</h3>
              <div className="intro__links--buttons">
                <Link
                  to="/special-events"
                  className="intro__links--button my-btn"
                >
                  Event Styling
                </Link>
              </div>
            </div>
          </div>

          <div className="intro__links--card ">
            <div className="intro__links--image">
              <SlideShow slides={safePostcards} />
            </div>
            <div className="intro__links--card-content slideshow__card">
              <h3>Postcards From Bribie Island Picnics</h3>
            </div>
          </div>
        </div>
      </section>

      {/* Booking Section */}
      <section className="info__booking--container ">
        <div className="info__booking--cards-header">
          <h2>How To Book</h2>
        </div>

        <div className="info__booking--cards">
          <div className="info__booking--card">
            <h3>Choose Your Setting</h3>
            <ul className="info__booking--card-ul">
              <li>Couples</li>
              <li>Group</li>
              <li>Proposal</li>
              <li>Event Styling</li>
            </ul>
          </div>

          <div className="info__booking--card">
            <h3>Choose Your ....</h3>
            <ul className="info__booking--card-ul">
              <li>Date</li>
              <li>Time</li>
              <li>Location</li>
              <li>Additions/Enhancements</li>
            </ul>
          </div>

          <div className="info__booking--card">
            <h3>Contact Us</h3>
            <ul className="info__booking--card-ul">
              <li>
                <Link to="/booking">
                  <h4 className="info__booking--cart-book my-btn">Book Now</h4>
                </Link>
              </li>
              <li>We will then confirm</li>
              <li>your booking request</li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}
